import { render, staticRenderFns } from "./ViewShowDial.vue?vue&type=template&id=a8315b9e&scoped=true&"
import script from "./ViewShowDial.vue?vue&type=script&lang=js&"
export * from "./ViewShowDial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8315b9e",
  null
  
)

export default component.exports